import ContentLoader from 'react-content-loader';

function SummaryPanelLoading() {
  return (
    <ContentLoader
      data-testid="summaryPanelLoading"
      speed={2}
      width={375}
      height={238}
      viewBox="0 0 375 238"
      backgroundColor="#fafafa"
      foregroundColor="#ecebeb"
    >
      <rect x="16" y="16" rx="2" ry="2" width="104" height="16" />
      <rect x="24" y="64" rx="2" ry="2" width="212" height="18" />
      <rect x="260" y="64" rx="2" ry="2" width="91" height="18" />
      <rect x="24" y="94" rx="2" ry="2" width="212" height="18" />
      <rect x="260" y="94" rx="2" ry="2" width="91" height="18" />
      <rect x="24" y="124" rx="2" ry="2" width="212" height="18" />
      <rect x="260" y="124" rx="2" ry="2" width="91" height="18" />
      <rect x="24" y="166" rx="6" ry="6" width="327" height="48" />
    </ContentLoader>
  );
}

export default SummaryPanelLoading;
